import { render, staticRenderFns } from "./UploadGi.vue?vue&type=template&id=47680ff2&"
import script from "./UploadGi.vue?vue&type=script&lang=js&"
export * from "./UploadGi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports